import React from 'react';
import style from './PrizesTable.css';

export const PrizesTable = ({ tableTitle, tableRightName, tableLeftName, data }) => {

    const dataToRender = data.map(e => {
        return (
            <li className={style.horizontalList} key={e.description}>
                <div className={style.prizesTableRow}>
                    <div className={style.leftTitle}>{e.operator === 'GTE' ? `${e.operands[0]}+` : `${e.operands[0]}-${e.operands[1]}` }</div>
                    <div className={style.rightTitle}>{e.description}</div>
                </div>
                <div className={style.divider}></div>
            </li>
        );
    });

    if (data.length > 0) {
        return (
            <div className={style.wrapper}>
                <div className={style.headerTitleWrapper}>
                    <div className={style.headerTitle}>{tableTitle}</div>
                </div>
                <div className={style.headerRow}>
                    <div className={style.leftTitle}>{tableLeftName}</div>
                    <div className={style.rightTitle}>{tableRightName}</div>
                </div>
                <div>
                    <ul className={style.clearDefStyles}>{dataToRender}</ul>
                </div>
            </div>);
    }
    return (<></>);
};

